/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import moment from 'moment';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { imageUrl } from '../../../../../Components/helper';
import noImage from '../../../../../assets/images/no-image.png';

function CareInstructionDetail({ suggestionType, handleSelectAllSymbol, onSelectCheckBoxSymbol, role, autoApproved, ele, oldSuggestion }) {
  const { t } = useTranslation('common');

  const dateFormat = 'DD-MM-YYYY, h:mm a';

  const setImage = (image) => {
    let imagePath = '';
    if (image?.includes('data:image/')) {
      imagePath = image;
    } else if (image?.includes('images/')) {
      imagePath = `${imageUrl}/${image}`;
    } else if (image) {
      imagePath = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${image}`;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };

  const renderValue = (column, value) => {
    switch (column?.columnDetails?.columnType?.key) {
      case 'Status':
        return (
          <div className="background-td-color w-100" style={{ backgroundColor: column?.columnDetails?.status?.colourHexCode }}>
            <span>{column?.columnDetails?.status?.colourName}</span>
          </div>
        );
      case 'Radio_button':
      case 'Dropdown':
        return value?.name || '';
      case 'Image':
        return <img src={setImage(value?.image) || noImage} alt={column?.name} width="70px" height="70px" />;
      case 'Multi_select_Dropdown':
        return value?.map((val) => val?.label).join(', ') || '';
      case 'Date_picker':
        return (value && moment(value).format('DD-MM-YYYY')) || '';
      default:
        return !value || typeof value === 'object' ? '' : value;
    }
  };
  const showCreatedandModified = (rowDetails, text) => {
    return (
      <button aria-label="Information" type="button" className="btn d-inline-flex">
        <OverlayTrigger
          placement="bottom"
          trigger="hover"
          rootClose
          overlay={
            <Popover className="custom-popover modified-popover">
              <Popover.Content>
                <div>
                  <p className="text-left m-0">
                    {text === 'approved' ? (
                      <strong> {autoApproved ? t('TESTING_SUGGESTION.AUTO_APPROVED_BY') : t('TESTING_SUGGESTION.APPROVED_BY')}&nbsp; </strong>
                    ) : (
                      <strong>{t('SYMBOLS.SYMBOLS_DETAIL.REJECTED_BY')} </strong>
                    )}
                    {`${rowDetails?.[0]?.approvedRejectedBy?.firstName} ${rowDetails?.[0]?.approvedRejectedBy?.lastName} `}
                  </p>
                  <p className="text-left m-0">
                    {text === 'approved' ? (
                      <strong> {t('SYMBOLS.SYMBOLS_DETAIL.APPROVED_AT')}</strong>
                    ) : (
                      <strong>{t('SYMBOLS.SYMBOLS_DETAIL.REJECTED_AT')}</strong>
                    )}{' '}
                    {moment(rowDetails?.[0]?.approvedRejectedAt).format(dateFormat)}
                  </p>

                  <p className="text-left m-0">
                    <strong> {t('SYMBOLS.SYMBOLS_DETAIL.COMMENTS')}</strong>
                    {rowDetails?.[0]?.comment}
                  </p>
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <i className="icon icon-Information f-20" />
        </OverlayTrigger>
      </button>
    );
  };
  const renderStatus = (rowDetails) => {
    const status = rowDetails?.[0]?.status;

    if (status === 'Approved') {
      return (
        <div className="d-flex align-items-center">
          <span className="col-status right approved" />
          {t('SYMBOLS.SYMBOLS_DETAIL.APPROVED')}
          {showCreatedandModified(rowDetails, 'approved')}
        </div>
      );
    }

    if (status === 'Rejected') {
      return (
        <div className="d-flex align-items-center">
          <span className="col-status right rejected" />
          {t('SYMBOLS.SYMBOLS_DETAIL.REJECTED')}
          {showCreatedandModified(rowDetails, 'rejected')}
        </div>
      );
    }

    return (
      <>
        <span className="col-status right pending" />
        {t('SYMBOLS.SYMBOLS_DETAIL.PENDING')}
      </>
    );
  };

  const renderOriginalStatus = (rowDetails) => {
    const status = rowDetails?.[0]?.status;

    if (status === 'Approved') {
      return (
        <div className="d-flex align-items-center">
          <span className="col-status right approved" />
          {t('SYMBOLS.SYMBOLS_DETAIL.APPROVED')}
          {showCreatedandModified(rowDetails, 'approved')}
        </div>
      );
    }

    if (status === 'Rejected') {
      return (
        <div className="d-flex align-items-center">
          <span className="col-status right rejected" />
          {t('SYMBOLS.SYMBOLS_DETAIL.REJECTED')}
          {showCreatedandModified(rowDetails, 'rejected')}
        </div>
      );
    }
    if (status === 'Deleted') {
      return (
        <div className="d-flex align-items-center">
          <span className="col-status right deleted" />
          {t('SYMBOLS.SYMBOLS_DETAIL.ORIGINAL_DATA_EXIST')}{' '}
        </div>
      );
    }

    return (
      <div className="d-flex align-items-center">
        <span className="col-status right pending" />
        {t('SYMBOLS.SYMBOLS_DETAIL.PENDING')}
      </div>
    );
  };

  const hasPendingStatus = (tabDetails, rowId) => {
    if (!tabDetails?.length) return false;
    const rowItems = tabDetails.filter((detail) => detail.rowId === rowId);
    return rowItems.some((item) => !['Approved', 'Deleted'].includes(item.status));
  };
  // To check if a specific rowId has pending status
  const uniqueRowIds = [...new Set(ele.tabDetails.map((detail) => detail.rowId))];

  // To check if any rowId in a tab has pending status
  const hasAnyPending = uniqueRowIds.some((rowId) => hasPendingStatus(ele.tabDetails, rowId));

  return suggestionType && suggestionType === 'new' ? (
    <div className="table-responsive">
      <table className="table mb-0 common-custom-table min-w-150 tbody-striped">
        <thead>
          <tr>
            {role !== 'Supplier' && hasAnyPending && (
              <th aria-label="check" className="w-80px">
                <div className="common-checkbox margin-auto">
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelectAllSymbol(e, ele?.tabDetails, ele?.tabId)}
                    name={`check_all_symbol_${ele?.tabId}`}
                    id={`check_all_symbol_${ele?.tabId}`}
                    checked={ele?.selectAll}
                    // disabled={defaultChecked || disabledCheckBox}
                    // disabled={allUsers.length > 0 ? false : true}
                  />
                  <label htmlFor={`check_all_symbol_${ele?.tabId}`} className="chklabel">
                    <span />
                  </label>
                </div>
              </th>
            )}

            <th className="w-150px">{t('SYMBOLS.SYMBOLS_DETAIL.NEW_SUGGESTION')}</th>
            {ele?.tabColumns?.length > 0 &&
              ele?.tabColumns
                ?.sort((a, b) => a.sequence - b.sequence) // Sort the columns based on the sequence/order
                .map((column) => (
                  <th key={column?._id} className="w-150px">
                    {column?.name}
                  </th>
                ))}
            <th aria-label="Status" className="w-150px last-fix-col">
              {t('SYMBOLS.SYMBOLS_DETAIL.STATUS')}
            </th>
          </tr>
        </thead>
        <tbody>
          {ele?.tabDetails?.length > 0 &&
            [...new Set(ele?.tabDetails?.sort((a, b) => a.sequence - b.sequence).map((detail) => detail.rowId))].map((row) => {
              const rowDetails = ele?.tabDetails?.filter((detail) => detail.rowId === row);
              const uniqueRow = [
                ...new Set(
                  ele?.tabDetails
                    ?.sort((a, b) => a.sequence - b.sequence)
                    .filter((detail) => !['Approved', 'Deleted'].includes(detail.status))
                    .map((detail) => detail.rowId),
                ),
              ];
              return (
                <tr key={ele?._id}>
                  {role !== 'Supplier' && (rowDetails?.[0]?.status === 'Approved' || rowDetails?.[0]?.status === 'Deleted') && hasAnyPending && <td />}
                  {role !== 'Supplier' && rowDetails?.[0]?.status !== 'Approved' && rowDetails?.[0]?.status !== 'Deleted' && (
                    <td className="w-80px">
                      <div className="common-checkbox no-label margin-auto">
                        <input
                          onChange={() => {
                            onSelectCheckBoxSymbol(ele?.selectedIds, row, uniqueRow, ele.tabId);
                          }}
                          name={`checks_symbol_${row}_${ele?.tabId}`}
                          id={`checks_symbol_${row}_${ele?.tabId}`}
                          type="checkbox"
                          // disabled={defaultChecked || disabledCheckBox}
                          checked={ele?.selectedIds?.includes(row)}
                        />
                        <label htmlFor={`checks_symbol_${row}_${ele?.tabId}`} className="chklabel">
                          <span />
                        </label>
                      </div>
                    </td>
                  )}

                  <td>{t('SYMBOLS.SYMBOLS_DETAIL.SUGGESTION')}</td>
                  {ele?.tabColumns
                    ?.sort((a, b) => a.sequence - b.sequence)
                    .map((column) => {
                      const data = rowDetails?.find((detail) => detail.columnId === column?._id);

                      return (
                        <td key={column?._id} className="w-100px">
                          {renderValue(column, data?.value)}
                        </td>
                      );
                    })}
                  <td className="position-relative">{renderStatus(rowDetails)}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="table-responsive">
      <table className="table mb-0 common-custom-table min-w-150 tbody-striped">
        <thead>
          <tr>
            {role !== 'Supplier' && hasAnyPending && (
              <th aria-label="check" className="w-80px">
                <div className="common-checkbox margin-auto">
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelectAllSymbol(e, ele?.tabDetails, ele?.tabId)}
                    name={`check_all_symbol_${ele.tabId}`}
                    id={`check_all_symbol_${ele.tabId}`}
                    checked={ele?.selectAll}
                    // disabled={defaultChecked || disabledCheckBox}
                    // disabled={allUsers.length > 0 ? false : true}
                  />
                  <label htmlFor={`check_all_symbol_${ele.tabId}`} className="chklabel">
                    <span />
                  </label>
                </div>
              </th>
            )}
            <th className="w-100px">{t('SYMBOLS.SYMBOLS_DETAIL.ORIGINAL_SUGGESTION')}</th>

            {ele?.tabColumns?.length > 0 &&
              ele?.tabColumns
                ?.sort((a, b) => a.sequence - b.sequence) // Sort the columns based on the sequence/order
                .map((column) => (
                  <th key={column?._id} className="w-150px">
                    {column?.name}
                  </th>
                ))}
            <th aria-label="Status" className="w-150px last-fix-col">
              {t('SYMBOLS.SYMBOLS_DETAIL.STATUS')}
            </th>
          </tr>
        </thead>

        {ele?.tabDetails?.length > 0 &&
          [...new Set(ele?.tabDetails?.sort((a, b) => a.sequence - b.sequence).map((detail) => detail.rowId))].map((row) => {
            const uniqueRow = [
              ...new Set(
                ele?.tabDetails
                  ?.sort((a, b) => a.sequence - b.sequence)
                  .filter((detail) => !['Approved', 'Deleted'].includes(detail.status))
                  .map((detail) => detail.rowId),
              ),
            ];
            const rowDetails = ele?.tabDetails?.filter((detail) => detail.rowId === row);
            // Find matching tab from oldSuggestion
            const matchingOldTab = oldSuggestion?.find((oldTab) => oldTab?.tabId === ele?.tabId);
            // Find matching row details from oldTab
            const oldData = matchingOldTab?.tabDetails?.filter((detail) => detail.rowId === row) || [];
            const originalRowDetails = ele?.originalItem?.filter((detail) => detail.rowId === row);
            return (
              <tbody key={row}>
                {rowDetails?.[0]?.status === 'Approved'
                  ? ele?.originalItem?.length > 0 && (
                      <tr>
                        {role !== 'Supplier' && hasAnyPending && <td />}

                        <td>{t('SYMBOLS.SYMBOLS_DETAIL.ORIGINAL')}</td>
                        {ele?.tabColumns
                          ?.sort((a, b) => a.sequence - b.sequence)
                          .map((column) => {
                            const data = originalRowDetails?.find((detail) => detail.columnId === column?._id);
                            return (
                              <td key={column?._id} className="w-100px">
                                {renderValue(column, data?.value)}
                              </td>
                            );
                          })}
                        <td aria-label="check" />
                      </tr>
                    )
                  : oldData.length > 0 && (
                      <tr>
                        {role !== 'Supplier' && hasAnyPending && <td />}
                        <td>{t('SYMBOLS.SYMBOLS_DETAIL.ORIGINAL')}</td>

                        {ele?.tabColumns
                          ?.sort((a, b) => a.sequence - b.sequence)
                          .map((column) => {
                            const data = oldData?.find((detail) => detail.columnId === column?._id);
                            return (
                              <td key={column?._id} className="w-150px">
                                {renderValue(column, data?.value)}
                              </td>
                            );
                          })}
                        <td aria-label="check" />
                      </tr>
                    )}

                <tr>
                  {role !== 'Supplier' && (rowDetails?.[0]?.status === 'Approved' || rowDetails?.[0]?.status === 'Deleted') && hasAnyPending && <td />}
                  {role !== 'Supplier' && rowDetails?.[0]?.status !== 'Approved' && rowDetails?.[0]?.status !== 'Deleted' && (
                    <td>
                      <div className="common-checkbox no-label margin-auto">
                        <input
                          onChange={() => {
                            onSelectCheckBoxSymbol(ele?.selectedIds, row, uniqueRow, ele?.tabId);
                          }}
                          name={`checks_symbol_${row}_${ele?.tabId}`}
                          id={`checks_symbol_${row}_${ele?.tabId}`}
                          type="checkbox"
                          // disabled={defaultChecked || disabledCheckBox}
                          checked={ele?.selectedIds?.includes(row)}
                        />
                        <label htmlFor={`checks_symbol_${row}_${ele?.tabId}`} className="chklabel">
                          <span />
                        </label>
                      </div>
                    </td>
                  )}

                  <td>{t('SYMBOLS.SYMBOLS_DETAIL.SUGGESTION')}</td>
                  {rowDetails?.[0]?.status !== 'Approved' &&
                    ele?.tabColumns
                      ?.sort((a, b) => a.sequence - b.sequence)
                      .map((column) => {
                        const olddata = oldData?.find((detail) => detail.columnId === column?._id);
                        const newData = rowDetails?.find((detail) => detail.columnId === column?._id);
                        let changedValue = false;
                        if (typeof newData?.value === 'string') {
                          changedValue = newData?.value !== olddata?.value;
                        }
                        if (typeof newData?.value === 'object') {
                          changedValue = JSON.stringify(newData?.value) !== JSON.stringify(olddata?.value);
                        }
                        return (
                          <td key={column?._id} className="w-150px">
                            <div className={changedValue && 'suggested-data'}>{renderValue(column, newData?.value)}</div>
                          </td>
                        );
                      })}
                  {rowDetails?.[0]?.status === 'Approved' &&
                    ele?.tabColumns
                      ?.sort((a, b) => a.sequence - b.sequence)
                      .map((column) => {
                        const data = rowDetails?.find((detail) => detail.columnId === column?._id);
                        return (
                          <td key={column?._id} className="w-150px">
                            {renderValue(column, data?.value)}
                          </td>
                        );
                      })}

                  <td className="position-relative">{renderOriginalStatus(rowDetails)}</td>
                </tr>
              </tbody>
            );
          })}
      </table>
    </div>
  );
}

export default CareInstructionDetail;
